import chat, { guestChat } from './chat'
import disputes from './disputes'

const dai = { chat, guestChat, disputes }

export default dai
